<template>
    <nav class="navbar cal-navbar-default navbar-fixed-top">
        <div class="container-fluid">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                        data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <a class="navbar-brand" href="#">
                    <img src="images/logo.jpg" style="height:78px" alt="">
                </a>
            </div>

            <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">

                <ul class="nav navbar-nav navbar-right">
                    <li :class="activeMenuItemId === 'cal-slider-menu-item' ? 'active-menu-item' : ''"
                        @click="setActiveMenuItem('cal-slider-menu-item')">
                        <a href="#" v-scroll-to="'#cal-slider'" data-toggle="collapse" data-target=".navbar-collapse.in">Home</a>
                    </li>
                    <li :class="activeMenuItemId === 'cal-about-menu-item' ? 'active-menu-item' : ''"
                        @click="setActiveMenuItem('cal-about-menu-item')">
                        <a href="#" v-scroll-to="'#cal-about'" data-toggle="collapse" data-target=".navbar-collapse.in">Über
                            uns</a>
                    </li>
                    <li :class="activeMenuItemId === 'cal-services-menu-item' ? 'active-menu-item' : ''"
                        @click="setActiveMenuItem('cal-services-menu-item')">
                        <a href="#" v-scroll-to="'#cal-services'" data-toggle="collapse" data-target=".navbar-collapse.in">Leistungen</a>
                    </li>
                    <li :class="activeMenuItemId === 'cal-appointment-menu-item' ? 'active-menu-item' : ''"
                        @click="setActiveMenuItem('cal-appointment-menu-item')">
                        <a href="#" v-scroll-to="'#cal-appointment'" data-toggle="collapse"
                           data-target=".navbar-collapse.in">Rechtsgebiete</a>
                    </li>
                    <li :class="activeMenuItemId === 'cal-testimonials-menu-item' ? 'active-menu-item' : ''"
                        @click="setActiveMenuItem('cal-testimonials-menu-item')">
                        <a href="#" v-scroll-to="'#cal-testimonials'" data-toggle="collapse"
                           data-target=".navbar-collapse.in">Testimonials</a>
                    </li>
                    <li :class="activeMenuItemId === 'cal-timeline-menu-item' ? 'active-menu-item' : ''"
                        @click="setActiveMenuItem('cal-timeline-menu-item')">
                        <a href="#" v-scroll-to="'#cal-timeline'" data-toggle="collapse" data-target=".navbar-collapse.in">Berufliche
                            Stationen</a>
                    </li>
                    <li :class="activeMenuItemId === 'cal-news-menu-item' ? 'active-menu-item' : ''"
                        @click="setActiveMenuItem('cal-news-menu-item')">
                        <a href="#" v-scroll-to="'#cal-news'" data-toggle="collapse" data-target=".navbar-collapse.in">Publikationen</a>
                    </li>
                    <li :class="activeMenuItemId === 'cal-contact-us-menu-item' ? 'active-menu-item' : ''"
                        @click="setActiveMenuItem('cal-contact-us-menu-item')">
                        <a href="#" v-scroll-to="'#cal-contact-us'" data-toggle="collapse"
                           data-target=".navbar-collapse.in">Kontakt</a>
                    </li>

                </ul>
            </div>
        </div>
    </nav>

</template>

<script>
    import {debounce} from 'lodash';

    export default {
        name: 'Header',
        components: {},
        data () {
            return {
                time: Date.now(),
                activeMenuItemId: 'cal-slider-menu-item',
                headerElements: [
                    {menuItemId: 'cal-slider-menu-item', id: 'cal-slider'},
                    {menuItemId: 'cal-about-menu-item', id: 'cal-about'},
                    {menuItemId: 'cal-services-menu-item', id: 'cal-services'},
                    {menuItemId: 'cal-appointment-menu-item', id: 'cal-appointment'},
                    {menuItemId: 'cal-testimonials-menu-item', id: 'cal-testimonials'},
                    {menuItemId: 'cal-timeline-menu-item', id: 'cal-timeline'},
                    {menuItemId: 'cal-news-menu-item', id: 'cal-news'},
                    {menuItemId: 'cal-contact-us-menu-item', id: 'cal-contact-us'},
                ]
            };
        },
        mounted () {
            window.addEventListener('scroll', debounce(this.resetActiveMenuItem));
            this.resetActiveMenuItem();
        },
        methods: {
            getPosition (element) {
                let xPosition = 0;
                let yPosition = 0;

                while (element) {
                    xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
                    yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
                    element = element.offsetParent;
                }

                return {x: xPosition, y: yPosition};
            },
            resetActiveMenuItem () {
                const scrollPos = window.scrollY;
                let activeMenuItem = this.headerElements[0].menuItemId;
                let element;
                this.headerElements.map(el => {
                    element = document.getElementById(el.id);
                    const elementScroll = this.getPosition(element);
                    if (elementScroll.y - 103 - 50 <= scrollPos) {
                        activeMenuItem = el.menuItemId;
                    }
                });
                this.activeMenuItemId = activeMenuItem;
            },
            setActiveMenuItem (activeMenuItem) {
                this.activeMenuItemId = activeMenuItem;
            }
        }
    };
</script>
